
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 15px",
        height: '58px',
        "& h2": {
            padding: '0px 15px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
             fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    container: {
        padding: '10px',
        paddingBottom: window.isIpadView ? '100px': '10px',
    },
    settingContainer: {
        padding: window.isMobileView ? '10px 10px' : '10px 20px',
        "& h3": {
            width: '100%',
            borderBottom: '1px solid #d6d6d6',
            padding: '10px 0px',
            fontSize: '18px',
        },
        "& p": {
            fontSize: '16px',
        }
    },
    greyBorderBox: {
        border: '1px solid #e3e3e3',
        padding: '20px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        margin: '5px',
        flexFlow: 'column',
        minHeight: '270px',
        borderRadius: '19px',
        "& h3": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '28px',
            lineHeight: '39px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#3C4549',
            margin: '18px 0px',
        },
        "& img": {
            marginTop: '20px'
        }
    },
    changeBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    table: {
        padding: '0px 20px',
    },



    root: {
        width: 65,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(38px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `0px solid ${theme.palette.grey[400]}`,
        backgroundColor: '#c3c3c3',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},

    settingOptions: {
        borderBottom: '1px solid #e8e8e8',
        padding: '12px 0px 5px 0px',
        marginLeft: '2%',
        marginRight: '2%',
    },
    remindMe: {
        minWidth: '60px',
        maxWidth: '250px',
        margin: '0px 15px',
    },

    footer: {
        flex: "0 1 40px",
        width: '100%',
        marginLeft: 'auto',
        paddingTop: '10px',
    },
    footerRight: {
        float: "right",

        display: 'flex',

    },


}))